module.exports = __webpack_public_path__ + "img/pin-deep-core.e684a43f.png";